import { practiceService } from '../models/database';
import samplePractices from '../data/sample-practices.json';

/**
 * Import sample practices data into Firestore
 * @returns {Promise<string[]>} Array of practice IDs that were imported
 */
export const importSamplePractices = async () => {
  try {
    console.log('Importing sample practices data...');
    const practiceIds = await practiceService.importPractices(samplePractices);
    console.log(`Successfully imported ${practiceIds.length} practices.`);
    return practiceIds;
  } catch (error) {
    console.error('Error importing sample practices:', error);
    throw error;
  }
};

/**
 * Check if practices already exist in the database
 * @returns {Promise<boolean>} True if practices exist, false otherwise
 */
export const checkPracticesExist = async () => {
  try {
    const practices = await practiceService.getAllPractices();
    return practices.length > 0;
  } catch (error) {
    console.error('Error checking if practices exist:', error);
    return false;
  }
};

/**
 * Import sample practices if none exist in the database
 * @returns {Promise<boolean>} True if practices were imported, false if they already existed
 */
export const importSamplePracticesIfNoneExist = async () => {
  try {
    const practicesExist = await checkPracticesExist();
    
    if (!practicesExist) {
      await importSamplePractices();
      return true;
    }
    
    console.log('Practices already exist in the database. Skipping import.');
    return false;
  } catch (error) {
    console.error('Error in importSamplePracticesIfNoneExist:', error);
    throw error;
  }
};
